import { UserLocationInfo } from '../../types/geo';
import { MAP_LAST_USED_LOCAL_STORAGE_KEY } from '../../constants/geo';
import { isBrowser } from '../misc/misc';

export interface ExpireablePosition extends UserLocationInfo {
  timeStamp: number;
}

export function setLastUsedPosition(pos: UserLocationInfo | null): ExpireablePosition | null {
  if (isBrowser()) {
    if (!pos) {
      localStorage.removeItem(MAP_LAST_USED_LOCAL_STORAGE_KEY);
      return null;
    }
    const posWithTime: ExpireablePosition = { ...pos, timeStamp: new Date().getTime() };
    localStorage.setItem(MAP_LAST_USED_LOCAL_STORAGE_KEY, JSON.stringify(posWithTime));
    return posWithTime;
  }
  return null;
}

export function getLastUsedPosition(): ExpireablePosition | null {
  if (isBrowser()) {
    const pos: ExpireablePosition = localStorage.getItem(MAP_LAST_USED_LOCAL_STORAGE_KEY)
      ? JSON.parse(localStorage.getItem(MAP_LAST_USED_LOCAL_STORAGE_KEY) || 'null')
      : ({} as ExpireablePosition);

    // TODO: this is not working if `lat` or `lng` is `0`
    if (pos && pos.coords && pos.coords.lat && pos.coords.lng && pos.city && pos.zipCode) {
      return pos;
    }
    return null;
  }
  return null;
}
